import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=77f215c9&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=77f215c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f215c9",
  null
  
)

export default component.exports